// src/utils/mergeStationsWithResultsAndEntries.js
//
// Ergebnis-Objekte tragen seit der Umstellung auf stabile Team-IDs beides:
// `team_id` als Bezug (danach wird verglichen) und `team_name` als Anzeige.
// Der Rueckfall auf das alte Freitextfeld `team` deckt Ranking-Dokumente ab,
// die noch vor der Umstellung geschrieben wurden.
export default function mergeStationsWithResultsAndEntries(stations = [], resultsStations = [], rawEntries = []) {
  const resultsMap = new Map(resultsStations.map(r => [Number(r.station_number), r.results || []]));
  const rawByStation = rawEntries.reduce((acc, r) => {
    const key = Number(r.station_number);
    (acc[key] ||= []).push(r);
    return acc;
  }, {});

  const bezug = (r) => r.team_id ?? r.team ?? null;

  return (stations || []).map((s) => {
    const sn = Number(s.station_number);
    const raw = rawByStation[sn];
    const calc = resultsMap.get(sn) || [];

    // Fallback: Wenn keine rawEntries vorhanden, nimm calc direkt
    const effectiveResults = raw?.length
      ? raw.map(r => {
          const key = bezug(r);
          const passend = calc.find(c => bezug(c) === key);
          return {
            team_id: r.team_id ?? null,
            team_name: r.team_name ?? r.team ?? null,
            entry_by: r.entry_by ?? null,
            estimate_value: r.estimate_value ?? null,
            performance_score: r.performance_score ?? null,
            points: passend?.points ?? null,
          };
        })
      : calc.map(c => ({
          ...c,
          team_id: c.team_id ?? null,
          team_name: c.team_name ?? c.team ?? null,
        }));

    return {
      ...s,
      results: effectiveResults,
    };
  });
}
